/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useQuery } from '@apollo/client';

import type { SeoLinkBoxInput } from '@xing-com/crate-common-graphql-types';
import { SeoLinkBoxesDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

type EntryByLetterParams = {
  jobRole: string;
};

export const useGetTopLocations = ({
  jobRole,
}: EntryByLetterParams): {
  loading: boolean;
  collection: {
    displayName: string;
    url: string;
  }[];
} => {
  const variables: SeoLinkBoxInput = {
    jobRole,
    serpType: 'jobRole',
  };
  const { data, loading } = useQuery(SeoLinkBoxesDocument, {
    variables,
  });
  const popularLocations = data?.seoLinkBoxes?.collection.find(
    (item) => item?.kind === 'popular_location'
  );
  const collection = popularLocations
    ? popularLocations.entries.map((entry) => ({
        displayName: entry?.name || '',
        url: entry?.url || '',
      }))
    : [];

  return { loading, collection };
};
